export default __webpack_public_path__ + "static/media/B16 00_00_00-01_36_00.mp4.10aa9c9f.mp4";